var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIskFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h62.503v45H0V0Z",
    fill: "#003897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.503h17.503V0h9.994v17.503h35.006v9.994H27.497V45h-9.994V27.497H0v-9.994Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.997h19.997V0h5.006v19.997h37.5v5.006h-37.5V45h-5.006V25.003H0v-5.006Z",
    fill: "#D72828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIskFlag);
export default __webpack_public_path__ + "static/media/isk-flag.5f01351b97e864776ec3397df2ada2ea.svg";
export { ForwardRef as ReactComponent };